export default __webpack_public_path__ + "static/media/Victor_Plata_Resume.091f63e5.pdf";